const category = 'AppSpecificInvestigation';
const displayMode = 'tabs';
const pageData = {
    title: 'QFD Rules Engine',
    subtitle: 'Configure automated rules for dispute processing',
}

const cards = [
    {
        name: "First Party Fraud",
        id: "firstPartyFraud",
        fields: [
            [
                {
                    type: "content",
                    content: `
                        <h6 class="heading">First Party Fraud Factors</h6>
                    `,
                },
            ],
            [
                {
                    id: "FirstPartyFraudFactors",
                    layout: [
                        [{ id: "BalanceCheckPriorToPurchase" }],
                        [{ id: "CorrectPINUse" }],
                        [{ id: "eWalletTransactions" }],
                        [{ id: "FoundDeclines" }],
                        [{ id: "HistoryWithSameMerchant" }],
                        [{ id: "LegitUseAfterLost" }],
                        [{ id: "NewAccount" }],
                        [{ id: "SimilarMerchantHistory" }],
                        [{ id: "TransactionVelocity" }],
                        [{ id: "TransactionWithChipRead" }],
                        [{ id: "TrialMerchant" }],
                    ],
                },
            ],
        ],
    },
    {
        name: "True Fraud",
        id: "trueFraud",
        fields: [
            [
                {
                    type: "content",
                    content: `
                        <h6>True Fraud Factors</h6>
                    `,
                },
            ],
            [
                {
                    id: "TrueFraudFactors",
                    layout: [
                        [{ id: "ActivationDateVsExpected" }],
                        [{ id: "BackToBackATMWithdrawals" }],
                        [{ id: "BalanceDeclines" }],
                        [{ id: "BalanceInquiries" }],
                        [{ id: "DeclineVelocity" }],
                        [{ id: "DrainedBalance" }],
                        [{ id: "ExpeditedCard" }],
                        [{ id: "FraudScore" }],
                        [{ id: "Geovariance" }],
                        [{ id: "HighFraudScore" }],
                        [{ id: "IncreasedATMUsage" }],
                        [{ id: "InvalidPINAttempts" }],
                        [{ id: "NoHistoryInCity" }],
                        [{ id: "NonUSMOPOMerchant" }],
                        [{ id: "OnlineRegistration" }],
                        [{ id: "ProfileChanges" }],
                        [{ id: "RecentPINChanges" }],
                        [{ id: "TestTransactions" }],
                        [{ id: "SpendingPatternAmount" }],
                    ],
                },
            ],
        ],
    },
];

export { cards, category, displayMode, pageData };